/* tslint:disable */
/* eslint-disable */
/**
 * rb-c3po-warehouse
 * API für die Verwaltung von Warenausgangsaufträgen, Artikeln, Chargen und Seriennummern
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * Total number of documents in collection that match a query
     * @type {number}
     * @memberof Pageable
     */
    totalItems?: number;
    /**
     * Limit that was used
     * @type {number}
     * @memberof Pageable
     */
    limit?: number;
    /**
     * Availability of prev page
     * @type {boolean}
     * @memberof Pageable
     */
    hasPrevPage?: boolean;
    /**
     * Availability of next page
     * @type {boolean}
     * @memberof Pageable
     */
    hasNextPage?: boolean;
    /**
     * Current page number
     * @type {number}
     * @memberof Pageable
     */
    page?: number;
    /**
     * Total number of pages.
     * @type {number}
     * @memberof Pageable
     */
    totalPages?: number;
    /**
     * Only if specified or default page/offset values were used
     * @type {number}
     * @memberof Pageable
     */
    offset?: number;
    /**
     * Previous page number if available or NULL
     * @type {number}
     * @memberof Pageable
     */
    prevPage?: number;
    /**
     * Next page number if available or NULL
     * @type {number}
     * @memberof Pageable
     */
    nextPage?: number;
    /**
     * The starting index/serial/chronological number of first document in current page.
     * @type {number}
     * @memberof Pageable
     */
    pagingCounter?: number;
}

/**
 * Check if a given object implements the Pageable interface.
 */
export function instanceOfPageable(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PageableFromJSON(json: any): Pageable {
    return PageableFromJSONTyped(json, false);
}

export function PageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pageable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'hasPrevPage': !exists(json, 'hasPrevPage') ? undefined : json['hasPrevPage'],
        'hasNextPage': !exists(json, 'hasNextPage') ? undefined : json['hasNextPage'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'prevPage': !exists(json, 'prevPage') ? undefined : json['prevPage'],
        'nextPage': !exists(json, 'nextPage') ? undefined : json['nextPage'],
        'pagingCounter': !exists(json, 'pagingCounter') ? undefined : json['pagingCounter'],
    };
}

export function PageableToJSON(value?: Pageable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalItems': value.totalItems,
        'limit': value.limit,
        'hasPrevPage': value.hasPrevPage,
        'hasNextPage': value.hasNextPage,
        'page': value.page,
        'totalPages': value.totalPages,
        'offset': value.offset,
        'prevPage': value.prevPage,
        'nextPage': value.nextPage,
        'pagingCounter': value.pagingCounter,
    };
}

